import { OptionCampo } from './Option';
export class CampoForm {
  name: string = '';
  label: string = '';
  type: number = 1;
  visible: boolean = true;
  find_mode: boolean = false;
  search: number = 0;
  list_view: boolean = true;
  option: OptionCampo[] = [];
  file: any[] = [];
  option_search: string = '';
  row: number = 1;
  column: number = 1;
  group: number = 0;
  group_label: string = '';
  disabled: boolean = false;
  required: boolean = false;
  settings: boolean = false;
  value: string = '';
  value_list: any[] = [];
}
